/**
 * Highlight occurrences of `query` within `text`.
 * Returns a React fragment with <mark> tags around matches.
 */
export function HighlightMatch({ text, query }: { text: string; query?: string }) {
  if (!query || !text) return <>{text}</>;
  const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const parts = text.split(new RegExp(`(${escaped})`, 'gi'));
  return (
    <>
      {parts.map((part, i) =>
        part.toLowerCase() === query.toLowerCase() ? (
          <mark
            // biome-ignore lint/suspicious/noArrayIndexKey: positional text split — index is stable
            key={`${i}-${part}`}
            className="bg-yellow-300 text-yellow-950 dark:bg-yellow-400/40 dark:text-yellow-100"
          >
            {part}
          </mark>
        ) : (
          part
        )
      )}
    </>
  );
}
